<script setup lang="ts">
import { useRoute } from '#app'
import {
  get1688ProductDetail,
  getWarehouseList,
  tbGlobalAddItemsToCart,
} from '@/api'
import { localeTo1688CountryMap ,isTarget_Blank} from '@/utils/globalData'
import { $t } from '@/utils/index'
import { Decimal } from 'decimal.js'
import { ElLoading } from 'element-plus'
import { getCurrencySymbol,getCurrencyNum } from "@/utils/goods";
import { get } from 'lodash-es'
import { inject, ref } from 'vue'
import { useMainStore } from '~/composables/store'
import { useCollect } from '~/composables/useCollect'
import { copyText } from '@/utils/index.js'
import {   watch } from "vue";

import VueImageZoom from '../common/VueImageZoom.vue'
import useLocate from './uses/useLocate.js'
import { useCdnDomain } from '~/composables/useCdnDomain'
const { locale } = useI18n()
const props = defineProps({
  allArcListMap: {
    type: Object,
    default: () => ({}),
  },
  currentElementIndex: {
    type: Array,
    default: () => [],
  },
  idx: {
    type: Number,
    default: -1,
  },
  parentKeys: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  config: {
    type: Object,
    default: () => ({}),
  },
})
const lodashGet = get
const store = useMainStore()

const mallUserInfo: any = computed(
  () => get(store, '$state.mallUserInfo') || {},
)

const page = ref<any>({})
const router = useRouter()
const route = useRoute()
function getRouteId() {
  return props.config.isGetRouteId
    ? (route.query && route.query.detailId) || ''
    : props.config.value
}

const { getLocaleText } = useLocate()
const { replaceCdnDomain } = useCdnDomain()

let detailId = getRouteId() || ''

const getPageData = inject(`detailData_${detailId}`)


watch(
    () => route,
    () => {
   
      nextTick(()=>{
        detailId=getRouteId();
        getProductDetail();
      })
     
     
    },
    { deep: true }
  );
let pageData = null
if (getPageData) {
  pageData = getPageData()
}

if (pageData && pageData.title) {
  page.value = pageData
}

const warehouseList = ref<
  {
    warehouseName: string
    warehouseCode: string
  }[]
>([])
async function getWarehouse() {
  /*
  const res = await getWarehouseList({
    shopId: storeInfo.id,
    param: {
      pageNo: 0,
      pageSize: 20,
      thirdPartyType: 'SZT',
    },
  })
  warehouseList.value = res.data
  */
}

// getWarehouse()

const productInfo = ref<any>({})
const productSkuInfos = computed(() => {
  if (!productInfo.value.productSkuInfos && productInfo.value.offerId) {
    const offerId = productInfo.value.offerId
    const price = productInfo.value.productSaleInfo?.price
    const amountOnSale = productInfo.value.productSaleInfo?.amountOnSale
    return [
      {
        skuAttributes: [
          {
            attributeId: offerId,
            attributeName:$t('texts.buyAmount'),
            value: '-',
          },
        ],
        specId: null,
        skuId: offerId,
        amountOnSale,
        price,
      },
    ]
  }
  return productInfo.value.productSkuInfos
})
const productImages = computed(() => {
  return productInfo.value.productImage?.images.map((img: string) => replaceCdnDomain(img)) || []
})
const productAttributes = computed(() => {
  const attrMap = new Map()
  productInfo.value.productAttribute?.forEach((attr: any) => {
    const { attributeName, value, valueTrans } = attr
    if (!attrMap.has(attributeName)) {
      attrMap.set(attributeName, {
        ...attr,
        values: [value],
        valuesTrans: [valueTrans],
      })
    }
    else {
      attrMap.get(attributeName).values.push(value)
      attrMap.get(attributeName).valuesTrans.push(valueTrans)
    }
  })

  const attrList = Array.from(attrMap.values())
  if (attrList.length % 2 !== 0) {
    attrList.push({
      attributeName: '',
      values: [],
      valuesTrans: [],
    })
  }
  return attrList
})
const productSpecs = computed(() => {
  const specMap = new Map()

  productSkuInfos.value?.forEach((sku: any) => {
    sku.skuAttributes.forEach((attr: any) => {
      const {
        attributeName,
        attributeNameTrans,
        attributeId,
        value,
        valueTrans,
        skuImageUrl,
      } = attr

      if (!specMap.has(attributeId)) {
        specMap.set(attributeId, {
          attributeId,
          attributeName,
          attributeNameTrans,
          attributeValues: new Map(),
 
        })
      }

      const spec = specMap.get(attributeId)
      if (!spec.attributeValues.has(value)) {
        spec.attributeValues.set(value, {
          value,
          valueTrans,
          skuImageUrl: skuImageUrl || null,
        })
      }
    })
  })

  return Array.from(specMap.values()).map(spec => ({
    ...spec,
    attributeValues: Array.from(spec.attributeValues.values()),
  }))
})

const slideIndex = ref(0)
const vueImageZoomOptions = computed(() => {
  return {
    height: 450,
    img: productImages.value[slideIndex.value],
    zoomStyle: 'height: 450px; border-radius: 12px; z-index: 9;',
    scale: 1,
    offset: { vertical: 0, horizontal: 14 },
    zoomPosition: 'right',
  }
})

const productError = ref(false)
async function getProductDetail() {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(255, 255, 255, 0.5)',
  })

  try {
    const res = await get1688ProductDetail({
      param: {
        country: localeTo1688CountryMap[locale.value]? localeTo1688CountryMap[locale.value]: "en",
        offerId: detailId,
      },
    })
    productInfo.value = res.data
    generateSkuMap()
    productError.value = false
  }
  catch (error) {
    productError.value = true
    console.error(error)
  }
  finally {
    loadingInstance.close()
  }
}

const skuMap = ref<{
  [skuId: string]: {
    buyQuantity: number
    [key: string]: any
  }
}>({})
function generateSkuMap() {
  const result: {
    [skuId: string]: {
      buyQuantity: number
      [key: string]: any
    }
  } = {}
  productSkuInfos.value?.forEach((sku: any) => {
    result[sku.skuId] = {
      ...sku,
      buyQuantity: 0,
    }
  })
  skuMap.value = result

  const len = productSkuInfos.value[0].skuAttributes.length
  productSkuInfos.value[0].skuAttributes.forEach((attr: any, index: number) => {
    if (index !== len - 1) {
      handleSelectSpecValue(attr.attributeId, attr)
    }
  })
}

const attrValueBuyQuantityMap = computed(() => {
  const result: {
    [skuOnlyValue: string]: number
  } = {}
  Object.keys(skuMap.value).forEach((skuId) => {
    const sku = skuMap.value[skuId]
    sku.skuAttributes.forEach((attr: any) => {
      if (result[`${attr.attributeId},${attr.value}`]) {
        result[`${attr.attributeId},${attr.value}`] += sku.buyQuantity
      }
      else {
        result[`${attr.attributeId},${attr.value}`] = sku.buyQuantity
      }
    })
  })
  return result
})

const selectedAttributes = ref<any>({})
function handleSelectSpecValue(attributeId: string, attrValue: any) {
  selectedAttributes.value = {
    ...selectedAttributes.value,
    [attributeId]: attrValue.value,
  }
}

function getSkuId(attributeId: string, value: string) {
  const _selectedAttributes: {
    [key: string]: string
  } = {
    ...selectedAttributes.value,
    [attributeId]: value,
  }
  const sku = productSkuInfos.value?.find((sku: any) =>
    sku.skuAttributes.every(
      (attr: any) => _selectedAttributes[attr.attributeId] === attr.value,
    ),
  )
  return sku?.skuId
}

function attrValueIsSelected(attributeId: string, value: string) {
  return selectedAttributes.value[attributeId] === value
}

const totalQuantity = computed(() => {
  const buyList = Object.values(skuMap.value).filter(
    item => item.buyQuantity > 0,
  )
  return buyList.reduce((total, item) => total + item.buyQuantity, 0)
})

/**
 * 1688 当前数量区间价格
 */
 const rangePrice = computed(() => {
  const quantity = totalQuantity.value;
  // 安全获取价格区间列表并创建副本
  const priceRangeList = [...(productInfo.value.productSaleInfo?.priceRangeList || [])];
  
  // 如果没有价格区间数据，返回0或您认为合适的默认值
  if (priceRangeList.length === 0) return 0;
  
  // 将区间按照起始数量从小到大排序
  priceRangeList.sort((a, b) => a.startQuantity - b.startQuantity);
  
  // 特殊情况：数量为0时返回最低区间的价格
  if (quantity === 0) return priceRangeList[0].price;
  
  // 从高到低检查区间
  for (let i = priceRangeList.length - 1; i >= 0; i--) {
    if (quantity >= priceRangeList[i].startQuantity) {
      return priceRangeList[i].price;
    }
  }
  
  // 如果没有匹配任何区间，返回最低区间的价格
  return priceRangeList[0].price;
});

const buyList = computed(() => {
  return Object.values(skuMap.value).filter(item => item.buyQuantity > 0)
})

const buyFirstAttrValueGroupList = computed(() => {
  const firstAttrValueGroupMap = new Map()

  buyList.value.forEach((item) => {
    const firstAttrValue = item.skuAttributes[0].value
    const skuStr = item.skuAttributes
      .slice(1)
      .map((item: any) => item.value)
      .join(' ')
    if (firstAttrValueGroupMap.has(firstAttrValue)) {
      const itemMap = firstAttrValueGroupMap.get(firstAttrValue)
      itemMap.value.push({
        ...item,
        skuStr,
        firstAttrValue,
      })
      itemMap.totalQuantity = add(itemMap.totalQuantity, item.buyQuantity)
    }
    else {
      firstAttrValueGroupMap.set(firstAttrValue, {
        key: firstAttrValue,
        value: [
          {
            ...item,
            skuStr,
            firstAttrValue,
          },
        ],
        totalQuantity: item.buyQuantity,
      })
    }
  })

  return firstAttrValueGroupMap.values().toArray()
})

const showBuyDetailList = ref(false)

function handleChangeShowBuyDetailList() {
  showBuyDetailList.value = !showBuyDetailList.value
}

function add(a: number, b: number) {
  return new Decimal(a).plus(new Decimal(b)).toNumber()
}

function multiply(a: number, b: number) {
  return new Decimal(a).times(new Decimal(b)).toNumber()
}

const buyTotalPrice = computed(() => {
  return buyList.value.reduce((total, item) => {
    const price = item.price
      ? multiply(item.price, item.buyQuantity)
      : multiply(rangePrice.value, item.buyQuantity)
    return add(total, price)
  }, 0)
})

const buyTotalQuantity = computed(() => {
  return buyList.value.reduce((total, item) => total + item.buyQuantity, 0)
})

const orderRemark = ref('')

/**
 * 提交订单
 */
async function handleSubmit() {
  if (!mallUserInfo.value.id) {
    ElMessage.error($t('placeholder.pleaseLogined'))
    router.push('/sub/mall/login')
    return
  }
  if (buyTotalQuantity.value < productInfo.value.minOrderQuantity) {
    ElMessage.error($t('placeholder.minAmountToBuy',{text:productInfo.value.minOrderQuantity})) 
    return
  }

  const cargoParamList: any[] = []
  const skuTextList: string[] = []

  const offerId = productInfo.value.offerId
  buyList.value.forEach((item) => {
    cargoParamList.push({
      offerId,
      specId: item.specId,
      quantity: item.buyQuantity,
    })

    skuTextList.push(
      `${item.skuAttributes.map((item: any) => item.value).join(' ')} x${
        item.buyQuantity
      },`,
    )
  })

  console.log('cargoParamList', cargoParamList)

  const addrInfo = warehouseList.value[0] || {}

  const goodInfo = [
    {
      title: productInfo.value.subject,
      pic: productImages.value[0],
      skuInfo: skuTextList.join(' '),
      warehouseName: addrInfo.warehouseName,
      orderRemark: orderRemark.value,
    },
  ]

  const tmBindInfo: any = {
    thirdPartyId: '',
  }

  const params = {
    isInvoice: 0, // 是否开发票
    goodInfo: JSON.stringify(goodInfo), // 商品信息

    flow: 'general', // 以下字段解释对应文档中解释
    message: '',
    isvBizType: 'cross',
    tradeType: null,
    shopPromotionId: null,
    anonymousBuyer: null,
    fenxiaoChannel: null,
    inventoryMode: null,
    outOrderId: null,
    pickupService: null,
    warehouseCode: null,
    preSelectPayChannel: null,
    smallProcurement: null,
    addressId: null, // 以下对应文档里面的addressParam下的字段
    logisticsFullName: `${get(addrInfo, 'concatInfos[0].contactName')}(${
      tmBindInfo.thirdPartyId
    })`,
    logisticsMobile: get(addrInfo, 'concatInfos[0].contactMobile'),
    logisticsPhone: get(addrInfo, 'concatInfos[0].contactMobile'),
    logisticsPostCode: get(addrInfo, 'concatInfos[0].postCode'),
    logisticsCityText:
      get(addrInfo, 'concatInfos[0].city') || get(addrInfo, 'city'),
    logisticsProvinceText:
      get(addrInfo, 'concatInfos[0].province') || get(addrInfo, 'province'),
    logisticsAreaText:
      get(addrInfo, 'concatInfos[0].district') || get(addrInfo, 'district'),
    logisticsTownText: get(addrInfo, 'townName'),
    logisticsAddress: `${get(addrInfo, 'concatInfos[0].address')
    || get(addrInfo, 'address')}-(${tmBindInfo.thirdPartyId})`,
    fastCargoList: cargoParamList,

    invoiceType: null, // 以下对应invoiceParam下的字段
    provinceText:
      get(addrInfo, 'concatInfos[0].province') || get(addrInfo, 'province'),
    cityText: get(addrInfo, 'concatInfos[0].city') || get(addrInfo, 'city'),
    areaText:
      get(addrInfo, 'concatInfos[0].district') || get(addrInfo, 'district'),
    townText: get(addrInfo, 'townName'),
    postCode: get(addrInfo, 'concatInfos[0].postCode'),
    address: `${get(addrInfo, 'concatInfos[0].address')
    || get(addrInfo, 'address')}-(${tmBindInfo.thirdPartyId})`,
    fullName: `${get(addrInfo, 'concatInfos[0].contactName')}(${
      tmBindInfo.thirdPartyId
    })`,
    phone: get(addrInfo, 'concatInfos[0].contactMobile'),
    mobile: get(addrInfo, 'concatInfos[0].contactMobile'),
    companyName: null,
    taxpayerIdentifier: null,
    bankAndAccount: null,
    localInvoiceId: null,
  }

  console.log('params', params)
  const confirmation1688OrderData: any = []
  buyList.value.forEach((o, i) => {
    confirmation1688OrderData.push({
      id: i,
      itemId: offerId,
      itemSkuId: o.specId,
      title: productInfo.value.subject,
      image: get(o, 'skuAttributes[0].skuImageUrl'),
      specsInfo: `${o.skuAttributes
        .map((item: any) => item.value)
        .join(' ')} x${o.buyQuantity}`,
      shopId: productInfo.value.sellerOpenId,
      shopNick: productInfo.value.sellerLoginId,
      quantity: o.buyQuantity,
      origin: 2,
      price: o.jxhyPrice * 100,
      specsInfoText: `${o.skuAttributes
        .map((item: any) => item.value)
        .join(' ')} x${o.buyQuantity}`,
    })
  })
  window.localStorage.setItem(
    'Confirmation1688OrderData',
    JSON.stringify(confirmation1688OrderData),
  )

  router.push('/sub/mall/Confirmation1688Order')
}

function makeOpenImgToSearch(url) {
  if (!url)
    return ''
  return `/product/search?searchType=img&imgSrc=${encodeURIComponent(url)}`
}

/**
 * 加入购物车
 */
async function handleAddToCart() {
  if (!mallUserInfo.value.id) {
    ElMessage.error($t('placeholder.pleaseLogined'))
    router.push('/sub/mall/login')
    return
  }
  if (buyTotalQuantity.value < productInfo.value.minOrderQuantity) {
    ElMessage.error($t('placeholder.minAmount{text}ToBuy',{text:productInfo.value.minOrderQuantity})) 
    return
  }

  const itemId = productInfo.value.offerId
  const param: any[] = []

  const shopNick = productInfo.value.sellerLoginId
  const shopId = productInfo.value.sellerOpenId
  const title = productInfo.value.subject
  buyList.value.forEach((item) => {
    let image = ''
    const specsInfo = item.skuAttributes
      .map((item: any) => {
        if (!image && item.skuImageUrl) {
          image = item.skuImageUrl
        }
        return item.value
      })
      .join(' ')

    if (!image) {
      image = productImages.value[0]
    }

    param.push({
      origin: 2,
      price: multiply(item.price || rangePrice.value, 100),
      itemSkuId: item.specId,
      quantity: item.buyQuantity,
      image,
      itemId,
      title,
      specsInfo,
      shopNick,
      shopId,
    })
  })

  await tbGlobalAddItemsToCart({
    param,
  })

  ElMessage({
    type: 'success',
    message:$t('messages.addToBuyCardSuccess') ,
    plain: true,
  })

  generateSkuMap()
}

const { hasCollect, addToCollect, cancelCollect } = useCollect(detailId)
function handleCollection() {
  if (hasCollect.value) {
    cancelCollect()
  } else {
    addToCollect()
  }
}

const currentAnchor = ref('description')

/**
 * 处理 productInfo.description 中的图片，为其添加 referrerpolicy="no-referrer"
 */
const processedDescription = computed(() => {
  if (!productInfo.value.description) return ''
  
  // 使用正则表达式找到所有 img 标签并添加 referrerpolicy="no-referrer"
  return productInfo.value.description.replace(
    /<img([^>]*?)>/gi,
    (match: string, attributes: string) => {
      // 检查是否已经有 referrerpolicy 属性
      if (attributes.includes('referrerpolicy=')) {
        // 如果已有 referrerpolicy 属性，替换它
        return `<img${attributes.replace(/referrerpolicy=["'][^"']*["']/gi, 'referrerpolicy="no-referrer"')}>`
      } else {
        // 如果没有 referrerpolicy 属性，添加它
        return `<img${attributes} referrerpolicy="no-referrer">`
      }
    }
  )
})

function handleToShopDetail() {
  const shopName = productInfo.value.transfersMap?.[productInfo.value.sellerLoginId] || productInfo.value.sellerLoginId
  const shopId = productInfo.value.sellerOpenId

  router.push({
    name: 'shop',
    query: {
      shopName,
      shopId,
    },
  })
}

function copyLink(){
  copyText(window.location.href)
}

onMounted(async () => {
  if (process.client) {
    console.log('process.client', process.client)
    console.log('pageData', pageData)
  }

  if (!page.value || !page.value.title) {
    getProductDetail()
  }
})
</script>

<template>
  <div class="goods_detail">
    <div v-if="productError" class="w-1400px flex bg-white rd-4 py-6 mx-auto transition-max-width">
      <div class="mr-4">
        <div class="i-ep:warning text-warning text-48px" />
      </div>
      <div>
        <h2 class="text-18px font-700">
          {{$t('placeholder.sorryThisGoodsIsSoldOut')}}

        </h2>
        <div class="text-14px text-gray-500 mt-4">
          {{$t('placeholder.ifYouSureGoodsIsOnSalePleaseRefresh')}}
        </div>
      </div>
    </div>
    <div v-else class="w-1400px bg-white rd-4 py-4 mx-auto transition-max-width">
      <div class="w-full flex mb-10">
        <!-- S-左侧 -->
        <div class="w-670px rd-3 mr-30px mt-10px">
           <!-- S-店铺名称 -->
           <div class="flex items-center b-b-1px b-b-solid b-b-#f5f5f5 pb-3 mb-3">
            <div class="w-24px h-24px i-custom:alibaba-1688 rd-2 mr-1" />
            <span class="text-16px font-700 mr-4">{{productInfo.transfersMap&&productInfo.transfersMap[productInfo.sellerLoginId]? productInfo.transfersMap[productInfo.sellerLoginId]:productInfo.sellerLoginId }}</span>
            <el-button type="primary" size="small" round @click="handleToShopDetail">
              {{$t('actions.viewStoreDetails')}}
            </el-button>
            <div>
              <a class="text-14px ml-10px text-warning no-underline items-center inline-flex "
                :href="`https://detail.1688.com/offer/${productInfo.offerId}.html`" :target="isTarget_Blank()">
                <i class="i-ep-link inline-block" />
                {{$t('texts.productLink')}}
              </a>
              <span class="ml-4 text-14px text-primary cursor-pointer items-center inline-flex " @click="getProductDetail">
                <i class="i-ep-refresh inline-block" />
                {{$t('actions.refresh')}}
              </span>
            </div>
          </div>
          <!-- E-店铺名称 -->
          <!-- S-标题 -->
          <div class="text-18px font-700 mb-20px flex  ">
            <div>{{localeTo1688CountryMap[locale]?  productInfo.subjectTrans :productInfo.subject }}</div>
           
          </div>
          <!-- E-标题 -->
          <div class="w-650px h-450px flex items-center rd-3">
            <VueImageZoom v-if="productImages[slideIndex]" :options="vueImageZoomOptions" />
          </div>
          <div class="overflow-hidden">
            <div class="w-max flex wrap mt-3">
              <div v-for="(item, index) in productImages" :key="item"
                class="relative w-68px h-68px rd-2 overflow-hidden cursor-pointer bg-gray-1"
                :class="[slideIndex === index ? 'pic-thumb_action' : '', index !== 0 ? 'ml-2' : '']"
                @mouseenter="slideIndex = index">
                <img class="max-w-full h-full m-auto" 
                     referrerpolicy="no-referrer"
                :src="item">
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between b-b-1px b-b-solid b-b-#f5f5f5 pb-2 mt-6">
            <a :target="isTarget_Blank()" :href="makeOpenImgToSearch(productImages[0])">
              <el-button type="primary" size="small" round plain>{{$t('actions.searchLikeGoods')}}</el-button>
            </a>
            <div class="flex items-center gap-4">
              <div @click="copyLink" class="flex items-center text-14px cursor-pointer">
                <span class="i-ep:share mr-1" />
                <span>{{$t('actions.shareGoods')}}</span>
              </div>
              <div class="flex items-center text-14px cursor-pointer" :class="hasCollect ? 'text-danger' : 'text-black'"
                @click="handleCollection">
                <div class="mr-1" :class="[hasCollect ? 'i-ant-design:star-filled' : 'i-ant-design:star-outlined']" />
                <div>{{$t('actions.collect')}}</div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4 p-4 bg-gray-1 rd-12px mt-6">
            <div class="text-14px">
              <span class="text-gray-500">{{$t('texts.saledNum')}}：</span>
              <span class="font-bold">{{ productInfo.soldOut || '--' }}</span>
            </div>
            <div class="text-14px">
              <span class="text-gray-500">{{$t('texts.averageDeliveryTime')}}：</span>
              <span class="font-bold">{{ productInfo.productShippingInfo?.averageDeliveryTime || '--' }}</span>
            </div>
            <div class="text-14px">
              <span class="text-gray-500">{{$t('texts.weight')}}（kg）：</span>
              <span class="font-bold">{{ productInfo.productShippingInfo?.weight?.toFixed(2) || '--' }}</span>
            </div>
            <div class="text-14px">
              <span class="text-gray-500">{{$t('texts.size')}}：</span>
              <span class="font-bold">{{ productInfo.productShippingInfo?.size || '--' }}</span>
            </div>
          </div>
          <el-tabs v-model="currentAnchor" class="w-full">
            <el-tab-pane :label="$t('texts.imagesInfoDetails')" name="description">
              <div class="w-full min-h200px mx-auto mt-4">
                <div class="description-html" v-html="processedDescription" />
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('texts.parameterDetail')" name="params">
              <div class="w-1008px mt-4">
                <div
                  class="box-border w-full flex flex-row flex-wrap b-t-1px b-r-0px b-b-0 b-l-1px b-solid b-gray-1 rd-3 overflow-hidden">
                  <div v-for="(infoItem) in productAttributes" :key="infoItem.attributeName"
                    class="box-border w-50% flex flex-row items-center b-t-0 b-r-1px b-b-1px b-l-0 b-solid b-gray-1 bg-white last:rd-rb-3">
                    <div class="w-160px min-h-60px text-14px flex items-center px-6 bg-gray-1"
                      :title="infoItem.attributeName">
                      {{localeTo1688CountryMap[locale]&&infoItem.attributeNameTrans? infoItem.attributeNameTrans : infoItem.attributeName }}
                    </div>
                    <div class="w-240px max-h-40px text-14px overflow-hidden mx-6 line-clamp-2"
                      :title="localeTo1688CountryMap[locale]&&infoItem.valuesTrans?infoItem.valuesTrans:infoItem.values.join(',')">
                      {{ localeTo1688CountryMap[locale]&&infoItem.valuesTrans?infoItem.valuesTrans.join(','):infoItem.values.join(',') }}
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('texts.proxyBuyGuide')"   name="guide">
              <div>
                <h6 class="lh-30px text-16px font-700 mt-4">
                  {{$t('proxyBuyGuide.unAccessGoods')}}
                  
                </h6>
                <p class="lh-30px text-14px mt-3">
                  {{$t('proxyBuyGuide.unAccess1')}}.
                </p>
                <p class="lh-30px text-14px text-gray-4">
                  {{$t('proxyBuyGuide.unAccessDetail1')}}.
                </p>
                <ul class="flex items-center gap-3 list-none">
                  <li class="w-120px h-120px rounded-4px overflow-hidden">
                    <img class="wh-full" src="https://cdn.static.hoobuy.com/assets/product/prohibited_1.webp" alt>
                  </li>
                  <li class="w-120px h-120px rounded-4px overflow-hidden">
                    <img class="wh-full" src="https://cdn.static.hoobuy.com/assets/product/prohibited_2.webp" alt>
                  </li>
                </ul>
                <h6 class="lh-30px text-16px font-700 mt-8">
                  {{$t('proxyBuyGuide.unAccessGoods1')}}.
                  
                </h6>
                <p class="lh-30px text-14px mt-3">
                  {{$t('proxyBuyGuide.unAccessGoods1Detail')}}.
                </p>
                <ul class="flex items-center gap-3 list-none">
                  <li class="w-120px h-120px rounded-4px overflow-hidden">
                    <img class="wh-full" src="https://cdn.static.hoobuy.com/assets/product/limited_1.webp" alt>
                  </li>
                  <li class="w-120px h-120px rounded-4px overflow-hidden">
                    <img class="wh-full" src="https://cdn.static.hoobuy.com/assets/product/limited_2.webp" alt>
                  </li>
                  <li class="w-120px h-120px rounded-4px overflow-hidden">
                    <img class="wh-full" src="https://cdn.static.hoobuy.com/assets/product/limited_3.webp" alt>
                  </li>
                  <li class="w-120px h-120px rounded-4px overflow-hidden">
                    <img class="wh-full" src="https://cdn.static.hoobuy.com/assets/product/limited_4.webp" alt>
                  </li>
                </ul>
                <h6 class="lh-30px text-16px font-700 mt-8">
                  
                  {{$t('texts.warningTip')}}
                </h6>
                <p class="lh-30px text-14px mt-3">
                  {{$t('proxyBuyGuide.unAccessGoods1Detail2')}}.
                </p>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('texts.saledService')" name="service">
              <div class="lh-30px text-sm bg-gray-1 rd-12px p-4 mt-4">
                <div>
                  <p>{{$t('proxyBuyGuide.warningTip1')}}.</p>
                  <p>{{$t('proxyBuyGuide.warningTip2')}}.</p>
                  <p>{{$t('proxyBuyGuide.warningTip3')}}.</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- E-左侧 -->
        <!-- S-右侧 -->
        <div class="flex-1">
          <el-card class="buy-card-box" >
            <div class="buy-card-box-in">
          <!-- S-价格 -->
          <div class="">
            <div v-if="productInfo.productSaleInfo?.price" class="vertical-top text-36px leading-none font-700">
              CNY ¥
              <span class="font-700">{{ productInfo.productSaleInfo?.price?.split('.')[0] }}</span>
              <span class="text-18px font-700">.{{ productInfo.productSaleInfo?.jxhyPrice?.split('.')[1] }}</span>
            </div>
            <div v-else class="flex items-center gap-12">
              <div v-for="(item, index) in productInfo.productSaleInfo?.priceRangeList" :key="index">
                <div class="vertical-top text-24px leading-none font-700">
                  CNY ¥
                  <span class="font-700">{{ item?.price?.split('.')[0] }}</span>
                  <span class="text-18px font-700">.{{ item?.price?.split('.')[1] }}</span>
                </div>

               
                <div v-if="getCurrencySymbol('¥')!='¥'" class="vertical-top text-14px  mt-5px mb-5px leading-none font-700">
                  <span class="text-18px font-700"> ≈{{getCurrencySymbol('¥')}} {{getCurrencyNum(item.price)}} </span>
                </div>
                <div class="text-14px">
                  {{ item?.startQuantity }}
                  {{ productInfo.productSaleInfo?.priceRangeList[index + 1] ? ` -
                  ${productInfo.productSaleInfo?.priceRangeList[index + 1]?.startQuantity - 1}` : '' }}
                  {{localeTo1688CountryMap[locale]&& productInfo.productSaleInfo?.unitInfo?.transUnit? productInfo.productSaleInfo?.unitInfo?.transUnit: productInfo.productSaleInfo?.unitInfo?.unit }}
                </div>
              </div>
            </div>
          </div>
          <!-- E-价格 -->
          <div class="buy-card-scroll-box">
          <!-- S-发货 -->
          <div class="mt-5">
            <div class="text-14px text-gray-500">
              {{$t('placeholder.payedWeWillDisposeYourOrderAt9_18')}}
            </div>
            <div class="w-full bg-gray-1 p-4 rd-3 mt-2">
              <div class="flex items-center text-14px font-400">
                <span
                  class="flex items-center justify-center block w-18px h-18px leading-none text-14px text-white rd-full bg-primary mr-2">1</span>
                <span>
                  {{$t('texts.saler')}}
                  <span class="text-gray-500">{{ lodashGet(productInfo,`transfersMap["${lodashGet(productInfo,'productShippingInfo.sendGoodsAddressText')}"]`)?lodashGet(productInfo,`transfersMap["${lodashGet(productInfo,'productShippingInfo.sendGoodsAddressText')}"]`): productInfo.productShippingInfo?.sendGoodsAddressText }}</span>
                </span>
                <span class="i-ep:arrow-right text-gray-500 mx-2" />
                <span>
                  {{$t('texts.warehouse')}}
                  <span class="text-blue-500 underline cursor-pointer">{{ warehouseList[1]?.warehouseName }}</span>
                </span>
              </div>
              <div class="flex items-center text-14px font-400 mt-4">
                <span
                  class="flex items-center justify-center block w-18px h-18px leading-none text-14px text-white rd-full bg-primary mr-2">2</span>
                <span>{{$t('texts.warehouse')}} {{ warehouseList[1]?.warehouseName }}</span>
                <span class="i-ep:arrow-right text-gray-500 mx-2" />
                <span>{{$t('texts.yourAddress')}} </span>
              </div>
            </div>
          </div>
          <!-- E-发货 -->

          <!-- S-规格 -->
          <div class="specification-wrap ">
            <div v-for="(spec, index) in productSpecs" :key="index" class="mt-5">
              <h6 class="text-16px font-700">
                {{ localeTo1688CountryMap[locale]&&spec.attributeNameTrans? spec.attributeNameTrans:spec.attributeName }}
              </h6>
              <div v-if="index !== productSpecs.length - 1" class="flex flex-wrap gap-2 p-0 mt-3">
                <div v-for="attrValue in spec.attributeValues" :key="attrValue.value" class="cursor-pointer relative"
                  @click="handleSelectSpecValue(spec.attributeId, attrValue)">
                  <div class="flex items-center p-1 bg-gray-1 rd-2 b-1px b-solid b-gray-2"
                    :class="[attrValueIsSelected(spec.attributeId, attrValue.value) ? ' b-primary! text-primary' : '']">
                    <img v-if="attrValue.skuImageUrl" :src="replaceCdnDomain(attrValue.skuImageUrl)" class="w-30px h-30px rd-4px">
                    <div class="text-14px px-2">
                      {{localeTo1688CountryMap[locale]&&attrValue.valueTrans?attrValue.valueTrans: attrValue.value }}
                    </div>
                  </div>
                  <div v-if="attrValueBuyQuantityMap[`${spec.attributeId},${attrValue.value}`] > 0"
                    class="absolute top-0 right-0 text-12px text-white bg-primary px-1 rd-4px">
                    x{{ attrValueBuyQuantityMap[`${spec.attributeId},${attrValue.value}`] }}
                  </div>
                </div>
              </div>
              <div v-else class="flex flex-col  py-5px mt-3">
                <div v-for="attrValue in spec.attributeValues" :key="attrValue.value">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center flex-1">
                      <img v-if="attrValue.skuImageUrl" :src="replaceCdnDomain(attrValue.skuImageUrl)"
                      
                              referrerpolicy="no-referrer"
                      class="w-30px h-30px rd-4px mr-1">
                      <div class="text-14px font-700 p-2 flex-1 min-w-10px"
                        :class="[attrValueIsSelected(spec.attributeId, attrValue.value) ? 'b-primary text-primary' : '']">
                        {{ localeTo1688CountryMap[locale]&&attrValue.valueTrans?attrValue.valueTrans: attrValue.value }}
                      </div>
                    </div>
                    <div class="flex items-center flex-1  min-w-10px">
                      <div class="text-14px font-700 mr-10px ml-10px flex flex-wrap w-100px">
                        <div class="text-nowrap" >{{ skuMap[getSkuId(spec.attributeId, attrValue.value)]?.price || rangePrice }}{{$t('unit.yuan')  }}</div>
                        <div class="text-nowrap text-size-12px"  v-if="getCurrencySymbol('¥')!='¥'"  >
                           ≈{{getCurrencyNum(skuMap[getSkuId(spec.attributeId, attrValue.value)]?.price || rangePrice )}} {{getCurrencySymbol('¥')}}
                        </div>
                      </div>
                      <div class="text-12px text-gray-500 w-80px ml-10px mr-10px text-nowrap">
                        {{ skuMap[getSkuId(spec.attributeId, attrValue.value)]?.amountOnSale||0}}{{" "}}{{
                          localeTo1688CountryMap[locale]&& productInfo.productSaleInfo.unitInfo?.transUnit?  productInfo.productSaleInfo.unitInfo?.transUnit: productInfo.productSaleInfo.unitInfo?.unit }}
                      </div>
                      <div>
                        <el-input-number
                        class="max-w-100px"
                          controls-position="right"
                         v-if="skuMap[getSkuId(spec.attributeId, attrValue.value)]"
                          v-model="skuMap[getSkuId(spec.attributeId, attrValue.value)].buyQuantity" :min="0"
                          :max="skuMap[getSkuId(spec.attributeId, attrValue.value)]?.amountOnSale" />
                        <el-input-number v-else
                        class="max-w-100px"
                            controls-position="right"
                          :model-value="0"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="w-full h-1px  " style="border-top: 1px dashed #e0e0e0;" />
                </div>
              </div>
            </div>
          </div>
          <!-- E-规格 -->

          <!-- S-合计 -->
          <div v-if="buyTotalPrice > 0" class="mt-5">
            <div class="relative w-full flex items-center bg-gray-1 rd-3 pl-3">
              <div class="flex items-baseline flex-grow-1">
                <div class="lh-56px mr-6 text-14px">
                  {{ $t('texts.total{text}Num', { text: buyTotalQuantity }) }}
                </div>
                <div class="h-56px flex flex-row items-center justify-center text-14px mr-3">
                  <div>
                    {{ $t('texts.goodsItemPrice') }}：
                    <span class="text-20px font-500 text-red-500">{{ buyTotalPrice }}</span>
                    {{ $t('unit.yuan') }}
                  </div>

                  <div v-if="getCurrencySymbol('¥')!='¥'" class="ml-10px"  >
                    <span class="text-14px font-400"> ≈ {{getCurrencyNum(buyTotalPrice)}}{{getCurrencySymbol('¥')}}  </span>
                  </div>
                </div>
              </div>
              <div class="w-148px h-56px flex items-center justify-center cursor-pointer text-14px relative"
                @click="handleChangeShowBuyDetailList">
                {{ $t('texts.selectedBuyGoodsList') }}：
                <span :class="[showBuyDetailList ? 'rotate-180' : '']"
                  class="i-ep:arrow-up px-1 transform transition-transform" />
              </div>

              <div v-if="showBuyDetailList"
                class="absolute bottom-full right-0 w-full bg-white rd-3 b-1px z-1 b-solid b-gray-1 transform-origin-bottom">
                <div v-for="item in buyFirstAttrValueGroupList" :key="item.key"
                  class="flex text-12px b-b-1px b-b-solid b-gray-1 last:border-none">
                  <div class="w-120px flex-center flex-wrap flex-shrink-0 p-4 text-center b-r-1px b-r-solid b-gray-1">
                    {{ item.key }}
                  </div>
                  <div v-if="item.value[0].skuAttributes && item.value[0].skuAttributes.length > 1"
                    class="w-120px flex-center flex-wrap flex-shrink-0 p-4 b-r-1px b-r-solid b-gray-1">
                    {{ item.totalQuantity }}
                  </div>
                  <div class="flex-1 p-4">
                    <div v-for="skuItem in item.value" :key="skuItem.skuId">
                      {{ `${skuItem.skuStr} (${skuItem.buyQuantity})` }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- E-合计 -->

          <!-- S-留言 -->
          <div class="mt-5">
            <h6 class="text-16px font-700 mb-3">
              {{ $t('texts.commentRemark') }}
            </h6>
            <el-input v-model="orderRemark" type="textarea" :maxlength="500" show-word-limit
              :placeholder="$t('placeholder.commentRemarkPlaceholder')" />
          </div>
          <!-- E-留言 -->
        </div>
           
          <!-- S-购买按钮 -->
          <div class="flex items-center mt-20px">
            <el-button type="primary" size="large"
              style="min-width: 180px; height: 50px; font-size: 18px; border-radius: 8px;" @click="handleSubmit">
              
              {{ $t('actions.fastToBuy') }}
            </el-button>
            <el-button type="primary" size="large"
              style="min-width: 180px; height: 50px; font-size: 18px; border-radius: 8px;" plain
              @click="handleAddToCart">
              {{ $t('actions.addBuyCart') }}
            </el-button>
          </div>
        </div>
          <!-- E-购买按钮 -->
          </el-card>
        </div>
        <!-- E-右侧 -->
      </div>

      <div w-full px-4>
      
      </div>
    </div>
  </div>
</template>

<style scoped>
div {
  box-sizing: border-box;
}

.pic-thumb_action::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  border: 4px solid #f9f7f3cc;
  z-index: 1;
}

.pic-thumb_action::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  border: 1px solid var(--el-color-primary);
  z-index: 2;
}

.el-textarea ::v-deep .el-textarea__inner {
  border-radius: 8px;
  font-size: 14px;
  /* border-color: #f56c6c; */
  background-color: #f3f4f6;
  color: #333;
}

.el-tabs ::v-deep .el-tabs__active-bar {
  height: 4px;
  border-radius: 4px;
}

.el-tabs ::v-deep .el-tabs__item {
  font-size: 18px;
  height: 68px;
  line-height: 68px;
}

.el-tabs ::v-deep .el-tabs__header {
  margin-bottom: 0;
}

.el-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
}
 
 

::v-deep .description-html img {
  max-width: 100% !important;
}

.buy-card-box{
  height:calc( 100vh - 130px );
  position: fixed;
  left:calc( 50% + 20px );
  top:115px;
  width: 650px;
  z-index: 8;
}
.buy-card-scroll-box{
  min-height: 200px;
  flex:1;
  overflow:auto;
}
.buy-card-box-in{
  height:calc( 100vh - 170px );
  display: flex;
  flex-direction: column;
}
.specification-wrap{
  max-width:530px;
}
@media(max-width:1400){
  .specification-wrap{
    max-width:730px;
  }
}
</style>
